const EMAIL_PATTERN = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const URL_PATTERN = /\b(?:https?:\/\/|www\.)\S+/gi;
const PHONE_PATTERN =
  /(?:\+\d[\d\s().-]{5,}\d)|(?:\(\d{3}\)\s*\d{3}[-.\s]?\d{4})|(?:\b\d{3}[-.\s]\d{3}[-.\s]\d{4}\b)/g;
const LONG_NUMBER_PATTERN = /\b\d{9,}\b/g;
const WHITESPACE_PATTERN = /\s+/g;

export interface ScrubbedText {
  text: string;
  wasScrubbed: boolean;
}

export const scrubQueryText = (value: string): ScrubbedText => {
  const normalized = value.replace(WHITESPACE_PATTERN, " ").trim();
  const text = normalized
    .replace(EMAIL_PATTERN, "[email]")
    .replace(URL_PATTERN, "[url]")
    .replace(PHONE_PATTERN, "[phone]")
    .replace(LONG_NUMBER_PATTERN, "[number]");

  return { text, wasScrubbed: text !== normalized };
};
